/**
 * NotificationType
 * Enum representing notification types.
 *
 * @property All - All notifications.
 * @property Chat - Chat notifications.
 * @property Calendar - Calendar notifications.
 * @property Assignment - Assignment notifications.
 * @property Group - Group notifications.
 * @property Grade - Grade notifications.
 * @property Fs - File system notifications.
 * @property Post - Post notifications.
 */
export enum NotificationType {
  All = 'all',
  Chat = 'chat',
  Calendar = 'calendar',
  Assignment = 'assignment',
  Group = 'group',
  Grade = 'grade',
  Fs = 'fs',
  Post = 'post',
}
